import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { TimesheetFilterComponent } from '../timesheet-filter/timesheet-filter.component';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { LookupService } from '../../../../services/lookup.service';
import { ErrorAlertService } from '../../../../shared/services/error-alert.service';
import { ListService } from '../../../../shared/services/list.service';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { DialogConfig, DialogService } from '../../../../shared/services/dialog.service';
import { PopupDialogComponent } from '../../../../shared/components/popup-dialog/popup-dialog.component';
import { CommonModule } from '@angular/common';
import { NzFormDirective } from 'ng-zorro-antd/form';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { CalendarModule } from 'primeng/calendar';
import { UserService } from '../../../../services/user.service';
import { TimesheetAdjustVoidEntryComponent } from '../timesheet-adjust-void-entry/timesheet-adjust-void-entry.component';
import { AutoFocusHeaderDirective } from '../../../../shared/directives/auto-focus-header.directive';

@Component({
  selector: 'ppl-timesheet-payroll-adjustment',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroModule,
    NzDatePickerModule,
    CalendarModule,
    ListTableComponent,
    TimesheetFilterComponent,
    TimesheetAdjustVoidEntryComponent,
    AutoFocusHeaderDirective
  ],
  templateUrl: './timesheet-payroll-adjustment.component.html',
  styleUrl: './timesheet-payroll-adjustment.component.css'
})
export class TimesheetPayrollAdjustmentComponent {
  @ViewChild(ListTableComponent) childComponent!: ListTableComponent;
  @ViewChild(TimesheetFilterComponent) timesheetFilterChildComponent!: TimesheetFilterComponent;
  @ViewChild('pendedDialog') pendedDialog!: TemplateRef<any>;
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  @ViewChild('timesheetAdjustVoidDialog') timesheetAdjustVoidDialog!: TemplateRef<any>;
  @ViewChild('searchFilterWarningDialog') searchFilterWarningDialog!: TemplateRef<any>;

  private dialogSvc = inject(DialogService);

  actionButtons: TableRowActionsModel = new TableRowActions({ view: false });
  appliedFilters: any;
  selectedAction: any;
  programName!: string;
  processingStatusList: any;
  businessStatusList: any;
  timesheets: any[] = [];
  serviceCodes: LookupValueItem[] = [];
  timesheetData: any = {};
  adjustVoidDialog: any;
  chequeNumbers: any[] = [];

  buttons = [
    {
      button_id: "Adjust",
      button_label: "Adjust",
      buttonAction: "adjustTimesheet",
      className: "primary-btn-color"
    },
    {
      button_id: "AdjustAll",
      button_label: "Adjust All",
      buttonAction: "adjustAllTimesheet",
      className: "primary-btn-color"
    },
    {
      button_id: "Void",
      button_label: "Void",
      buttonAction: "voidTimesheet",
      className: "primary-btn-color"
    },
    {
      button_id: "VoidAll",
      button_label: "Void All",
      buttonAction: "voidAllTimesheets",
      className: "primary-btn-color"
    }
  ]

  cols = [
    {
      field: 'service_date',
      header: 'Service \nDate',
      jsonpath: 'service_date',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'service_description',
      header: 'Service \nDescription',
      jsonpath: 'service_description',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'consumer_name',
      header: 'Consumer \nName',
      jsonpath: 'consumer_name',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'participant_ppl_id',
      header: 'Consumer \nPPL ID',
      jsonpath: 'participant_ppl_id',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
      isClickable: true
    },
    {
      field: 'provider_name',
      header: 'PA \nName',
      jsonpath: 'provider_name',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'provider_ppl_id',
      header: 'PA PPL ID',
      jsonpath: 'provider_ppl_id',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
      isClickable: true
    },
    {
      field: 'timeInTimeOut',
      header: 'Time In - \nTime Out',
      jsonpath: 'timeInTimeOut',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billed_units',
      header: 'Billed \nUnits \n(hrs)',
      jsonpath: 'billed_units',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paid_units',
      header: 'Paid \nUnits',
      jsonpath: 'paid_units',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'servicecode_rate',
      header: 'Service \nRate',
      jsonpath: 'servicecode_rate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'businessStatus',
      header: 'Business \nStatus',
      jsonpath: 'businessStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'processingStatus',
      header: 'Processing \nStatus',
      jsonpath: 'processingStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'source_type_lkp',
      header: 'Timesheet \nSource',
      jsonpath: 'source_type_lkp',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'mco_name',
      header: 'MCO \nName',
      jsonpath: 'mco_name',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'client_auth_number',
      header: 'Authorization \nNumber',
      jsonpath: 'client_auth_number',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'cba',
      header: 'CBA \nAssociation',
      jsonpath: 'cba',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    }
  ];

  fields = [
    { field: 'Timeframe', show: true, default: '30 days', extendedMonths: true, extendedYear: true },
    { field: 'consumer', show: true },
    { field: 'consumerPplId', show: true },
    { field: 'provider', show: true },
    { field: 'providerPplId', show: true },
    { field: 'payPeriod', show: true, multiple: true, hideFuturePeriods: true },
    { field: 'paymentDate', show: true },
    { field: 'serviceCode', show: true },
    { field: 'chequeNumber', show: true },
    { field: 'serviceDate', show: true, hideFuturePeriods: true },
  ];

  keyMapping: { [key: string]: string } = {
    Timeframe: "serviceDuration",
    serviceDate: "service_date",
    payPeriod: "tas_master_payroll_schedule_id",
    consumer: "consumer_name",
    consumerPplId: "participant_ppl_id",
    provider: "provider_name",
    providerPplId: "provider_ppl_id",
    chequeNumber: "cheque_number",
    paymentDate: "paid_tas_master_payroll_schedule_id",
    serviceCode: "servicecode_detail_id"
  };

  constructor(
    private listService: ListService,
    private fb: FormBuilder,
    private lookupService: LookupService,
    private dateTimeFormatterService: DateTimeFormatterService,
    private userService: UserService,
    private errorAlertService: ErrorAlertService
  ) { }

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.businessStatusList = this.lookupService.getLookupValue('Business Status');
    this.processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    this.serviceCodes = this.lookupService.getLookupValue('timesheet_filter_serviceCode');
  }

  searchTimesheets(filters: any, startingPageNumber = 1, currentPage = 0, isChequeLookUp = false) {
    if (startingPageNumber == 1) {
      this.timesheets = [];
    }

    const processedPayload = this.buildRequestPayload(
      'paidTimesheetList',
      'tas_timesheetline_detail_id',
      filters,
      startingPageNumber
    );

    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        const records = this.processData(data.responsedata);
        if (isChequeLookUp) {
          if (records && records?.length) {
            this.chequeNumbers = Array.from(
              new Set(records.filter((e: any) => e.cheque_number).map((e: any) => e.cheque_number)));
          }
        }
        else {
          if (startingPageNumber > 1) {
            this.timesheets = [...this.timesheets, ...records];
          } else {
            this.timesheets = records;
          }

          if (this.childComponent) {
            this.childComponent.resetPagination(startingPageNumber, currentPage);
          }

          if (this.timesheets?.length) {
             this.chequeNumbers = Array.from(
              new Set(records.filter((e: any) => e.cheque_number).map((e: any) => e.cheque_number)));
          }
        }
      });
  }

  buildRequestPayload(pageName: string, orderBy: string, searchParams: [], startingPageNumber = 1) {
    if (searchParams.length == 0) {
      return;
    }

    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ['desc'],
    };

    return payload;
  }

  processData(data: any) {
    if (data && data.length > 0) {
      data.forEach((element: any) => {
        element.timeInTimeOut = this.dateTimeFormatterService.convertTo12HourFormat(element.time_in) + ' - ' + this.dateTimeFormatterService.convertTo12HourFormat(element.time_out),
          element.businessStatus = this.businessStatusList.filter((status: any) => status.lkpValueCode === element.business_status_lkp)
            .map((status: any) => status.lkpValueName),
          element.processingStatus = this.processingStatusList.filter((status: any) => status.lkpValueCode === element.prcocessing_status_lkp)
            .map((status: any) => status.lkpValueName)
      });
    }

    return data;
  }

  onSearch(event: any) {
    const filters = [];
    filters.push({
      jsonPath: "serviceDuration",
      value: event.Timeframe ? event.Timeframe.substring(0, event.Timeframe.indexOf(' ')) : '30',
      operator: "lessthanorequal"
    });

    if (event.serviceDate) {
      filters.push({
        jsonPath: "service_date",
        value: this.dateTimeFormatterService.formatDateToString(event.serviceDate as Date),
        operator: "Equal"
      });
    }

    if (event.payPeriod && event.payPeriod.length > 0) {
      filters.push({
        jsonPath: "tas_master_payroll_schedule_id",
        values: event.payPeriod,
        operator: "In"
      });
    }

    if (event.consumer && event.consumer.trim()) {
      filters.push({
        jsonPath: "consumer_name",
        value: event.consumer.trim(),
        operator: "equal"
      });
    }

    if (event.consumerPplId && event.consumerPplId.trim()) {
      filters.push({
        jsonPath: "participant_ppl_id",
        value: event.consumerPplId.trim(),
        operator: "Equal"
      });
    }

    if (event.provider && event.provider.trim()) {
      filters.push({
        jsonPath: "provider_name",
        value: event.provider.trim(),
        operator: "equal"
      });
    }

    if (event.providerPplId && event.providerPplId.trim()) {
      filters.push({
        jsonPath: "provider_ppl_id",
        value: event.providerPplId.trim(),
        operator: "Equal"
      });
    }

    if (event.chequeNumber && event.chequeNumber.length) {
      filters.push({
        jsonPath: "cheque_number",
        values: event.chequeNumber,
        operator: "In"
      });
    }

    if (event.paymentDate) {
      filters.push({
        jsonPath: "paid_tas_master_payroll_schedule_id",
        value: event.paymentDate,
        operator: "Equal"
      });
    }

    if (event.serviceCode) {
      filters.push({
        jsonPath: "servicecode_detail_id",
        value: event.serviceCode,
        operator: "Equal"
      });
    }

    const hasRelevantFilter = filters.some(filter =>
      ["provider_name", "consumer_name", "provider_ppl_id", "participant_ppl_id"].includes(filter.jsonPath)
    );

    if (!hasRelevantFilter) {
      this.openWarningMessage();
      return;
    }

    this.appliedFilters = filters;
    this.searchTimesheets(filters, undefined, undefined, event.chequeLookUp);
  }

  openWarningMessage() {
    const dialogConfig: DialogConfig = {
      title: 'Error',
      showOkButton: true,
      isOkText: 'Ok',
      size: 'medium',
      position: 'top',
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.searchFilterWarningDialog,
      dialogConfig,
      () => { },
      () => { }
    );
  }

  convertTimeStringToDate(timeString: string): Date {
    const currentDate = new Date();
    const [hours, minutes] = timeString.split(':');
    currentDate.setHours(Number(hours), Number(minutes), 0, 0);
    return currentDate;
  }

  areArraysEqual(a: any[], b: any[]): boolean {
    if (!Array.isArray(a) || !Array.isArray(b))
      return false;

    if (a.length !== b.length)
      return false;

    return a.every((val, i) => val === b[i]);
  }

  isFilterValid(timesheetFilterValues: any, searchCallbackFilterValues: any) {
    const activeFilters = Object.keys(timesheetFilterValues).filter(key => {
      const value = timesheetFilterValues[key];
      if (value === null || value === undefined)
        return false;

      if (typeof value === 'string' && value.trim() === '')
        return false;

      if (Array.isArray(value) && value.length === 0)
        return false;

      return true;
    });

    if (activeFilters.length !== searchCallbackFilterValues.length)
      return false;

    return Object.entries(timesheetFilterValues)
      .filter(([_, value]) => value !== null && value !== "")
      .every(([key, value]: [any, any]) => {
        const mappedKey = this.keyMapping[key] || key;

        if (Array.isArray(value) && value.length === 0)
          return true;

        let comparisonValue: any;

        if (mappedKey === 'service_date') {
          comparisonValue = this.dateTimeFormatterService.formatDateToString(value as Date);
        }
        else if (mappedKey === 'serviceDuration') {
          comparisonValue = value.substr(0, value.indexOf(' '));
        } else {
          comparisonValue = value;
        };

        return searchCallbackFilterValues.some((filter: any) => filter.jsonPath === mappedKey &&
          (Array.isArray(filter.value || filter.values) ? this.areArraysEqual(filter.values, comparisonValue) :
            typeof filter?.value === 'string' ? filter?.value?.trim() === comparisonValue?.trim() : filter?.value === comparisonValue));
      });
  }

  gridAction(event: any) {
    const { button, selectedCheckBox } = event;

    if (!this.isFilterValid(this.timesheetFilterChildComponent.timesheetSearchForm.value, this.appliedFilters)) {
      const errorMessage = `Some filters are newly applied but the search is not performed. Kindly perform search with updated filter or remove the filter.`;
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (selectedCheckBox && selectedCheckBox.length === 0
      && (button.buttonAction === 'adjustTimesheet' || button.buttonAction === 'voidTimesheet')) {
      const errorMessage = `Kindly select checkbox and then perform this action.`;
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (selectedCheckBox.length > 1 && (button.buttonAction === 'adjustTimesheet' || button.buttonAction === 'voidTimesheet')) {
      const errorMessage = `Adjust / Void operation can be performed on single timesheet at a time.`;
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (button) {
      switch (button.buttonAction) {
        case 'adjustTimesheet': {
          const selectedTimesheet = selectedCheckBox[0];
          const selectedService = this.serviceCodes?.find(service => service.lkpValueCode === selectedTimesheet.servicecode_detail_id.toString());
          this.timesheetData = {
            tas_timesheetline_detail_id: selectedTimesheet.tas_timesheetline_detail_id,
            serviceDate: selectedTimesheet.service_date,
            serviceCode: selectedService,
            timeIn: selectedTimesheet.time_in,
            timeOut: selectedTimesheet.time_out,
            billedUnits: selectedTimesheet.billed_units
          };
          break;
        }
        case 'voidTimesheet': {
          const selectedTimesheet = selectedCheckBox[0];
          this.timesheetData = {
            tas_timesheetline_detail_id: selectedTimesheet.tas_timesheetline_detail_id
          };
          break;
        }
        case 'adjustAllTimesheet': {
          if (selectedCheckBox.length > 0) {
            this.timesheetData = {
              tas_timesheetline_detail_ids: selectedCheckBox.map((entry: any) => entry.tas_timesheetline_detail_id)
            }
          }
          break;
        }
        case 'voidAllTimesheets': {
          if (selectedCheckBox.length > 0) {
            this.timesheetData = {
              tas_timesheetline_detail_ids: selectedCheckBox.map((entry: any) => entry.tas_timesheetline_detail_id)
            }
          }
          break;
        }
      }

      this.selectedAction = button;

      const dialogConfig: DialogConfig = {
        title: `Payroll ${button.button_label}`,
        size: 'medium',
        position: 'top',
        showClose: true,
        showButtons: false,
        styleClass: this.selectedAction?.buttonAction !== 'adjustTimesheet' ? 'limit-dialog-width' : ''
      };

      this.adjustVoidDialog = this.dialogSvc.openDialog(
        this.timesheetAdjustVoidDialog,
        dialogConfig,
        () => this.handleCancel(),
        () => this.handleCancel()
      );
    }
  }

  closeAdjustVoidDialog() {
    this.timesheetData = {};
    if (this.adjustVoidDialog) {
      this.dialogSvc.closeDialog(this.adjustVoidDialog);
      this.adjustVoidDialog = null;
    }
  }

  handleCancel() {
    this.closeAdjustVoidDialog();
  }

  timesheetAdjustedOrVoided(event: any) {
    this.closeAdjustVoidDialog();
    this.searchTimesheets(this.appliedFilters, event.startingPageNumber, event?.first ?? 0);
  }
}
